module.exports = __webpack_public_path__ + "static/media/12-4.f1c25aec.mp3";